import axios from 'axios';

export default axios.create({
  baseURL: 'https://script.google.com/macros/s/AKfycbweN_lYAyS6iOqeqMlvij5Vnvh_o71mzoO1DBQjAUiljdggPxB2KgqVbY7Xg4nKsC4',
});
